angular.module('picmonicng').factory('Navigation', function () {
  return {
    topVisible: true,
  };
});
